import { useState } from "react";
import { HiOutlineChevronDown } from "react-icons/hi2";

/**
 * Labeled form-field wrapper that gives the composer form its consistent
 * rhythm: label row (with optional counter on the right), the control,
 * and an optional hint or error line below.
 */
const ComposerField = ({
    label = undefined,
    required = false,
    counter = undefined,
    hint = undefined,
    error = undefined,
    className = "",
    children
}) => {
    return (
        <div className={`flex flex-col ${className}`}>
            {(label || counter) && (
                <div className="flex items-baseline justify-between gap-3 mb-2">
                    {label && (
                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
                            {label}
                            {required && <span className="text-red-500 dark:text-red-400 ml-0.5">*</span>}
                        </label>
                    )}
                    {counter}
                </div>
            )}
            {children}
            {!!error
                ? <p className="text-xs text-red-500 dark:text-red-400 mt-1.5">{error}</p>
                : !!hint && <p className="text-xs text-tertiary-400 dark:text-gray-500 mt-1.5">{hint}</p>
            }
        </div>
    );
};

/**
 * Collapsible section ("Instagram options", "YouTube options", ...) used for
 * non-required, network-specific settings.
 */
export const ComposerCollapse = ({
    title,
    icon = undefined,
    defaultOpen = false,
    className = "",
    children
}) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className={`flex flex-col ${className}`}>
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between py-1 text-sm font-semibold text-gray-700 dark:text-gray-300 cursor-pointer select-none bg-transparent"
            >
                <span className="flex items-center gap-2">
                    {icon}
                    {title}
                </span>
                <HiOutlineChevronDown className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <div className="pt-4 flex flex-col gap-4">
                    {children}
                </div>
            )}
        </div>
    );
};

export default ComposerField;
